<script>
import pagination from "../mixins/Pagination";

export default {
    name: "Templates",
    mixins: [pagination],
    data() {
        return {
            showDialog: false,
            showMediaDialog: false,
            template: {}
        }
    },
    methods: {
        listApi() {
            return '/sterling/templates';
        },
        listParams() {
            return {}
        },
        onSelectFile(file) {
            this.template.src = file.src;
        },
        onSave() {
            let {template} = this;
            if (template.id) {
                this.$api.put(`/sterling/templates/${template.id}`, template).then(() => {
                    this.$message.success('Template updated');
                    this.showDialog = false;
                    this.fetchList();
                    this.template = {};
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            } else {
                this.$api.post('/sterling/templates', template).then(() => {
                    this.$message.success('Template saved');
                    this.showDialog = false;
                    this.fetchList();
                    this.template = {};
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                });
            }
        },
        onBatchDelete() {
            this.$confirm('are you sure?', 'Confirm', {
                type: 'warning'
            }).then(() => {
                let ids = this.selectionIds.map((d) => d.id);
                this.$api.delete('/sterling/templates/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            });
        },
        onShowEdit(T) {
            this.template = T;
            this.showDialog = true;
        },
        onDownload(T) {
            window.open(T.src);
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Templates</h2>
            <div>
                <el-button type="primary" size="small" @click="showDialog=true">New Template</el-button>
            </div>
        </div>
        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="title" label="Name"/>
                <el-table-column prop="description" label="Description"/>
                <el-table-column width="160" label="Options" align="right">
                    <template slot-scope="scope">
                        <a @click="onShowEdit(scope.row)">Edit</a>
                        <span>|</span>
                        <a @click="onDownload(scope.row)">Download</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablenav-bottom">
                <div class="table-actions">
                    <el-button size="small" type="primary" :disabled="selectionIds.length===0" @click="onBatchDelete">
                        Batch Delete
                    </el-button>
                </div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>

        <el-dialog title="New Template"
                   closeable
                   :visible.sync="showDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :modal-append-to-body="true"
                   :append-to-body="true"
                   @close="showDialog=false"
        >
            <el-form label-width="100px" size="medium">
                <el-form-item label="Name">
                    <el-input v-model="template.title"></el-input>
                </el-form-item>
                <el-form-item label="Description">
                    <el-input v-model="template.description" type="textarea" rows="3"></el-input>
                </el-form-item>
                <el-form-item label="URL">
                    <el-input v-model="template.src">
                        <template slot="append">
                            <el-button @click="showMediaDialog=true">Choose File</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSave">Save</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <media-dialog v-model="showMediaDialog" @confirm="onSelectFile"/>
    </main-layout>
</template>

<style scoped>

</style>